<template>
  <div class="city-picker">
    <input
      type="text"
      class="picker-input"
      v-model="query"
      :placeholder="placeholder"
      @input="onInput"
      @focus="onFocus"
      @blur="onBlur"
    >
    <span v-if="modelValue" class="picked-id">city_id: {{ modelValue }}</span>
    <ul v-if="open && (loading || results.length)" class="dropdown">
      <li v-if="loading" class="hint-item">Поиск…</li>
      <li
        v-for="c in results"
        :key="c.city_id"
        @mousedown.prevent="select(c)"
      >
        <span class="c-name">{{ c.city_name }}</span>
        <span class="c-region">{{ c.region_name || '' }}</span>
        <span class="c-id">{{ c.city_id }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { searchCities } from '@/backend/distributorRoutingApi'

export default {
  name: 'CityPicker',
  props: {
    modelValue: { type: [Number, String, null], default: null },
    placeholder: { type: String, default: 'Город' },
    initialName: { type: String, default: '' },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const query = ref(props.initialName || '')
    const results = ref([])
    const open = ref(false)
    const loading = ref(false)
    let timer = null

    const runSearch = () => {
      const q = query.value.trim()
      if (q.length < 2) {
        results.value = []
        return
      }
      loading.value = true
      searchCities(q)
        .then((data) => { results.value = Array.isArray(data) ? data : [] })
        .catch(() => { results.value = [] })
        .finally(() => { loading.value = false })
    }

    const onInput = () => {
      emit('update:modelValue', null)
      if (timer) clearTimeout(timer)
      timer = setTimeout(runSearch, 250)
    }

    const onFocus = () => { open.value = true }
    const onBlur = () => { setTimeout(() => { open.value = false }, 150) }

    const select = (c) => {
      query.value = c.city_name
      emit('update:modelValue', c.city_id)
      results.value = []
      open.value = false
    }

    watch(() => props.initialName, (v) => { query.value = v || '' })

    return { query, results, open, loading, onInput, onFocus, onBlur, select }
  },
}
</script>

<style scoped>
.city-picker { position: relative; }
.picker-input { background: #fff; border: 1px solid #d1d5db; border-radius: 8px; font-size: 13px; padding: 8px 10px; width: 100%; }
.picked-id { display: block; color: #6b7280; font-size: 10px; margin-top: 2px; font-family: ui-monospace, monospace; }
.dropdown { position: absolute; z-index: 50; top: 100%; left: 0; right: 0; background: #fff; border: 1px solid #d1d5db; border-radius: 8px; list-style: none; margin: 2px 0 0; padding: 4px; max-height: 240px; overflow-y: auto; box-shadow: 0 8px 24px rgba(15,23,42,0.12); }
.dropdown li { display: flex; gap: 8px; align-items: baseline; padding: 5px 6px; border-radius: 6px; cursor: pointer; font-size: 13px; }
.dropdown li:hover { background: #eef4ff; }
.c-name { font-weight: 600; color: #1f2937; }
.c-region { color: #6b7280; font-size: 11px; }
.c-id { margin-left: auto; color: #2563eb; font-size: 11px; font-family: ui-monospace, monospace; }
.hint-item { color: #6b7280; font-size: 12px; padding: 5px 6px; }
</style>
